// components/RadioGroup.jsx
import React from 'react';

export const RadioGroup = ({ 
  name, 
  checked, 
  onChange, 
  labelYes = 'Так', 
  labelNo = 'Ні' 
}) => {
  return (
    <div className="d-flex gap-3">
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name={name}
          id={`${name}_yes`}
          checked={checked}
          onChange={() => onChange(true)}
        />
        <label className="form-check-label" htmlFor={`${name}_yes`}>
          {labelYes}
        </label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name={name}
          id={`${name}_no`}
          checked={!checked}
          onChange={() => onChange(false)}
        />
        <label className="form-check-label" htmlFor={`${name}_no`}>
          {labelNo}
        </label>
      </div>
    </div>
  );
};